export default __webpack_public_path__ + "static/beige-nr-black-desserto-4152ca96738368a6b9fafb37eb0ecfa4.png";